import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {COPY_STRINGS} from '../../../constants/translatedCopy';
import {logSessionInfo} from '../../../services/logger';
import {getUserData, setUserData} from '../../../services/API';
import { GetBrandedAppName } from '../../../services/BrandingService';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";
import StudentInformationService from '../../../services/StudentInformationService';
import { 
  GetCharacterConfiguration, 
  getSelectableTutors, 
} from '../../../services/CharacterService';
import Loading from '../../Global/Loading';
import cx from 'classnames';
import whiteCheckmark from '../../../images/white_circle_checkmark.svg';

const TUTORS_PER_ROW = 2;

const TutorPicker = ({ fromStudentInbox, returnToInboxURL, history }) => {
  const title = COPY_STRINGS.select_tutor;
  const saveButtonText = COPY_STRINGS.save;
  
  const userData = getUserData();
  const [selectedTutor, setSelectedTutor] = useState(null);
  const [selectableTutorRows, setSelectableTutorRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const optionTitleClass = userData.isESL ? 'option-title esl' : 'option-title';

  useEffect(() => {
    const availableTutors = getSelectableTutors(userData);

    const characterConfiguration = GetCharacterConfiguration(userData);

    setSelectedTutor(
      availableTutors.find(
        tutor => tutor.rig === characterConfiguration.rig && tutor.skin === characterConfiguration.skin
      )
    );

    const groupedTutors = [];
    for (let i = 0; i < availableTutors.length; i += TUTORS_PER_ROW) {
      groupedTutors.push(availableTutors.slice(i, i + TUTORS_PER_ROW));
    }
    setSelectableTutorRows(groupedTutors);
  }, []);

  const onSelectTutor = (option) => {
    setSelectedTutor(option);
  }
  
  const handleSave = async () => {
    console.log("Saving selected tutor:", selectedTutor);
    setIsLoading(true);
    if (selectedTutor) {
      try {
        await StudentInformationService.setTutor(userData.userId, selectedTutor.rig, selectedTutor.skin);
        if (fromStudentInbox) {
          logSessionInfo('tutor_metadata_saved', selectedTutor);
          window.location.href = returnToInboxURL;
          return;
        } else {
          setUserData('selectedTutorRig', selectedTutor.rig);
          setUserData('selectedTutorSkin', selectedTutor.skin);
          history.push('/student/home');
          return;
        }
      } catch (error) {
        window.alert("Error saving tutor");
        console.error("Error saving tutor:", error);
      }

      logSessionInfo({
        event: 'tutor_selected',
        tutor: selectedTutor
      });

      setIsLoading(false);
    }
  }

  const getTutorOption = (tutorOption) => {
    const isSelected = selectedTutor && selectedTutor.skin === tutorOption.skin && selectedTutor.rig === tutorOption.rig;
    const classes = cx({
      'tutor': true,
      'selected': isSelected,
      'selectable': !isLoading
    })
    return (
      <div key={`${tutorOption.rig}-${tutorOption.skin}`} className="tutor-container">
        <div 
          className={classes}
          onClick={() => !isLoading && onSelectTutor(tutorOption)}
        >
          <img className="tutor-image" src={tutorOption.image} alt={tutorOption.skin} />
          {isSelected && <div className="selected-checkmark">
            <img src={whiteCheckmark} alt="checkmark" />
          </div>}
        </div>
      </div>
    )
  }
  return (
    <div className="tutor-picker">
      {isLoading && <div className="tutor-picker-loading">
        <Loading />
      </div>}
      <div className="title-container">
        <div className="tutor-picker-title">{title}</div>
      </div>
      <div className="tutors">
        {selectableTutorRows.map((row, rowIndex) => (
          <div key={`row-${rowIndex}`} className="tutor-row">
            {row.map((option) => getTutorOption(option))}
          </div>
        ))}
      </div>
      <div className="saveButton"
        {...doNotUseAccessibleStaticElementInteractions({onClick: !isLoading ? handleSave : null})}>
        <span className={optionTitleClass}>{saveButtonText}</span>
      </div>
    </div>
  );
}

export default withRouter(TutorPicker);
